export default __webpack_public_path__ + "static/media/icon-light-vehicle.ce326f9b.svg";